import "./ForestParkServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import ForestPark from "./sections/ForestPark";
import Services from "./sections/Services";
import Problems from "./sections/Problems";
import Faq from "./sections/Faq";
import Closingcta from "./sections/Closingcta";
import Footer from "@/reusable_sections/Footer";
export default function ForestParkServiceAreaPage() {
  return <div>
      <Header />
      <ForestPark />
      <Services />
      <Problems />
      <Faq />
      <Closingcta />
      <Footer />
    </div>;
}